import React, { useState } from "react";
import { AppBar, Divider, Grid } from "@mui/material";
import AttendanceLogForm from "./AttendanceLogForm";
import EmployeeAttendance from "./EmployeeAttendance";
import ShowAttendance from "./ShowAttendance";

const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const highlightStyle = "bg-[#ffa726]";

const AttendanceLog = () => {
  const [page, setPage] = useState(0);
  const [seletedMonth , setSelectedMonth] = useState(months[new Date().getMonth()])
  const currentYear = new Date().getFullYear();

  const handleMonthClick = (month) =>{
    setSelectedMonth(month);
  }

  // Render month bar
  const renderMonthGridItem = (month, index) => (
    <Grid
      item
      xs={1}
      key={index}
      className={seletedMonth === month ? `${highlightStyle} cursor-pointer` : "cursor-pointer"}
      onClick={()=>handleMonthClick(month)}
    >
      <div className="px-20 py-20">{`${month} ${currentYear}`}</div>
    </Grid>
  );

  return (
    <div className="h-full">
      <AppBar color="inherit" className="sticky z-20 mb-16">
        <Grid container spacing={2}>
          {months.map((month, index) => renderMonthGridItem(month, index))}
        </Grid>
        </AppBar>
        <AppBar color="inherit" className="sticky z-20 mb-16">
            
        <div className="flex flex-col space-y-16 sm:space-y-0 flex-1 w-full items-center justify-around text-center py-32 px-24 md:px-32">
          <Grid container spacing={2} className="flex justify-around">
            <Grid item xs={4}>
              <h3>Inbox (Pending Clarification)(2)</h3>
            </Grid>
            <Grid item xs={4}>
              <h3>Pending Leave (3)</h3>
            </Grid>
            <Grid item xs={4}>
              <h3>Public Holiday (3)</h3>
            </Grid>
          </Grid>
          <Grid container spacing={2} className="flex justify-around">
            <Grid item xs={4}>
              <h3>Showroom Opening (1)</h3>
            </Grid>
            <Grid item xs={4}>
              <h3>Confirmed Leaves (4)</h3>
            </Grid>
            <Grid item xs={4}>
              <h3>Internal Holiday (1)</h3>
            </Grid>
          </Grid>
          <Divider />
        </div>
      </AppBar>
     
      {page === 0 && <AttendanceLogForm setPage={setPage} />}
      {page === 1 && <EmployeeAttendance setPage={setPage} />}
      {page === 2 && <ShowAttendance setPage={setPage} />}
    </div>
  );
};

export default AttendanceLog;
